import { adminAPIService } from './index'

const route = 'subscription'

export default {
  getSubscriptions() {
    return adminAPIService({
      url: `${route}`,
      method: 'get',
    })
  },
}